function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/* global toastr */
import { compose, withState, withStateHandlers, withHandlers, withProps, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import { multipleNotesHide, multipleNotesAddApplicationId, multipleNotesClearApplicationIds, multipleNotesRemoveApplicationId } from "../../../store/actions/noteTemplates";
import { getMultipleApplicationsAction } from "../../../api/jsonapi";
import { createBulkNotesAction, createBulkNoteTemplateAction } from "../../../api";
import { renderNoteTemplate as api_renderNoteTemplate } from "../../../api/noteTemplates";
import { createApplicationNoteRequestMultipart } from "../../../api/application";
import { getApiObjectList } from "../../../util/common";
import componentErrorBoundary from "../../enhancers/componentErrorBoundary";
import handleApiErrorResponse from "../../../util/handleApiErrorResponse";
var getNoteTemplateFromId = function getNoteTemplateFromId(state, id) {
  if (!state || !state.api || !state.api.entities || !state.api.entities.note_templates || !id) return null;
  return state.api.entities.note_templates[id];
};
var addTemplateToApplication = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(template_id, application_id) {
    var response, data;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return api_renderNoteTemplate(template_id, application_id);
        case 2:
          response = _context.sent;
          data = response.data; // call two
          return _context.abrupt("return", createApplicationNoteRequestMultipart(application_id, {
            note_template_id: template_id,
            title: data.title,
            body: data.body,
            visibility: 'public'
          }));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function addTemplateToApplication(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var enhancer = compose(componentErrorBoundary, connect(function (state) {
  var _state$application;
  return {
    application_ids: state && state.noteTemplates && state.noteTemplates.multiple_notes_application_ids,
    current_application_id: state && state.application && state.application.applicationId,
    current_application: state && state.application && state.application.application,
    modal_visible: state && state.noteTemplates && state.noteTemplates.multiple_notes_modal_visible,
    note: state && state.noteTemplates && state.noteTemplates.multiple_notes_selected_note,
    template_id: state && state.noteTemplates && state.noteTemplates.multiple_notes_selected_template_id,
    template: getNoteTemplateFromId(state, state && state.noteTemplates && state.noteTemplates.multiple_notes_selected_template_id),
    isLegacyAdminTab: (state === null || state === void 0 ? void 0 : (_state$application = state.application) === null || _state$application === void 0 ? void 0 : _state$application.currentTab) && state.application.currentTab.toLowerCase() === 'admin comments'
  };
}, function (dispatch) {
  return {
    closeModalAction: function closeModalAction() {
      dispatch(multipleNotesHide());
      dispatch(multipleNotesClearApplicationIds());
    },
    handleAddApplicationId: function handleAddApplicationId(id) {
      return dispatch(multipleNotesAddApplicationId(id));
    },
    handleAddNoteTemplateToApplication: function handleAddNoteTemplateToApplication(template_id, application_id) {
      return dispatch(addTemplateToApplication(template_id, application_id));
    },
    handleRemoveApplicationId: function handleRemoveApplicationId(id) {
      return dispatch(multipleNotesRemoveApplicationId(id));
    },
    handleRemoveAllApplicationIds: function handleRemoveAllApplicationIds() {
      return dispatch(multipleNotesClearApplicationIds());
    },
    handleRetrieveMultipleApplications: function handleRetrieveMultipleApplications(ids) {
      return dispatch(getMultipleApplicationsAction({
        'filter[ids]': ids.join(','),
        include: 'program,program.school,student',
        'fields[students]': 'first_name,middle_name,last_name',
        'fields[schools]': 'name',
        'extra_fields[applications]': 'most_recent_note_author_type',
        'stats[total]': 'count',
        'page[size]': 1000
      }));
    }
  };
}), getApiObjectList('applications'), withState('sendNoteToAllApplications', 'setSendNoteToAllApplications', false), withState('downloadCsv', 'setDownloadCsv', false), withState('selectedLegacyApplicationIdsForBatchSend', 'setSelectedLegacyApplicationIdsForBatchSend', new Set()), withState('selectedApplicationIdsForBatchSend', 'setSelectedApplicationIdsForBatchSend', new Set()), withPropsOnChange(['applications', 'application_ids'], function (_ref2) {
  var applications = _ref2.applications,
    application_ids = _ref2.application_ids;
  return {
    applications_map: applications.filter(function (application) {
      return application_ids.indexOf(application.id) >= 0;
    }).reduce(function (response, application) {
      response[application.id] = application;
      return response;
    }, {})
  };
}), withStateHandlers({
  application_id_input: '',
  application_is_processing: false
}, {
  onChangeApplicationIds: function onChangeApplicationIds() {
    return function (value) {
      return {
        application_id_input: value
      };
    };
  },
  handleClearApplicationIdInput: function handleClearApplicationIdInput() {
    return function () {
      return {
        application_id_input: ''
      };
    };
  },
  handleAddIds: function handleAddIds(_ref3, _ref4) {
    var application_id_input = _ref3.application_id_input;
    var handleAddApplicationId = _ref4.handleAddApplicationId,
      handleRemoveAllApplicationIds = _ref4.handleRemoveAllApplicationIds,
      setSendNoteToAllApplications = _ref4.setSendNoteToAllApplications,
      setSelectedLegacyApplicationIdsForBatchSend = _ref4.setSelectedLegacyApplicationIdsForBatchSend,
      setSelectedApplicationIdsForBatchSend = _ref4.setSelectedApplicationIdsForBatchSend;
    return function () {
      var hasErrors = false;
      handleRemoveAllApplicationIds();
      setSendNoteToAllApplications(false);
      setSelectedLegacyApplicationIdsForBatchSend(new Set());
      setSelectedApplicationIdsForBatchSend(new Set());
      var ids = application_id_input.split(/[,\n ]/).map(function (e) {
        return e.trim();
      }).filter(function (e) {
        return e.length > 0;
      }).map(function (e) {
        var returnValue = parseInt(e, 10);
        if (Number.isNaN(returnValue)) {
          console.warn('Invalid entry: ', e);
          hasErrors = true;
          return null;
        }
        return returnValue;
      }).filter(Boolean);
      ids.forEach(handleAddApplicationId);
      if (hasErrors) {
        toastr.warning('One or more of your entries were invalid and it was ignored');
      }
      return {
        application_id_input: ''
      };
    };
  },
  setApplicationIsProcessing: function setApplicationIsProcessing() {
    return function (application_is_processing) {
      return {
        application_is_processing: application_is_processing
      };
    };
  }
}), withPropsOnChange(['application_ids'], function (_ref5) {
  var application_ids = _ref5.application_ids,
    applications_map = _ref5.applications_map,
    handleRetrieveMultipleApplications = _ref5.handleRetrieveMultipleApplications,
    setApplicationIsProcessing = _ref5.setApplicationIsProcessing;
  var existing_ids = Object.keys(applications_map).map(function (e) {
    return parseInt(e, 10);
  });
  var filtered_application_ids = application_ids.filter(function (e) {
    return existing_ids.indexOf(e) < 0;
  });
  var cached_id_count = application_ids.filter(function (e) {
    return existing_ids.indexOf(e) >= 0;
  }).length;
  if (filtered_application_ids.length <= 0) return;
  setApplicationIsProcessing(true);
  handleRetrieveMultipleApplications(filtered_application_ids).then(function (applications_response) {
    var applications_added = applications_response.body.data;
    var total_applications_available_count = applications_added.length + cached_id_count;
    if (total_applications_available_count != application_ids.length) {
      toastr.warning("Only ".concat(total_applications_available_count, " of ").concat(application_ids.length, " applications were added to the list. Please check invalid IDs and note limits."));
    }
    return applications_response;
  })["catch"](handleApiErrorResponse)["catch"](function () {}).then(function () {
    setApplicationIsProcessing(false);
    ReactTooltip.rebuild();
  });
}), withHandlers({
  handlePostNoteTemplates: function handlePostNoteTemplates(_ref6) {
    var closeModalAction = _ref6.closeModalAction,
      handleRemoveAllApplicationIds = _ref6.handleRemoveAllApplicationIds,
      isLegacyAdminTab = _ref6.isLegacyAdminTab,
      note = _ref6.note,
      selectedLegacyApplicationIdsForBatchSend = _ref6.selectedLegacyApplicationIdsForBatchSend,
      selectedApplicationIdsForBatchSend = _ref6.selectedApplicationIdsForBatchSend,
      setSendNoteToAllApplications = _ref6.setSendNoteToAllApplications,
      setSelectedLegacyApplicationIdsForBatchSend = _ref6.setSelectedLegacyApplicationIdsForBatchSend,
      setSelectedApplicationIdsForBatchSend = _ref6.setSelectedApplicationIdsForBatchSend,
      setApplicationIsProcessing = _ref6.setApplicationIsProcessing,
      template = _ref6.template,
      template_id = _ref6.template_id,
      createNotes = _ref6.createNotes,
      isMarkdownRendererEnabled = _ref6.isMarkdownRendererEnabled,
      noteType = _ref6.noteType;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _note$title, _note$body, result, result_data, applications_count;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setApplicationIsProcessing(true);
            if (!isMarkdownRendererEnabled) {
              _context2.next = 4;
              break;
            }
            createNotes({
              applicationIds: Array.from(selectedApplicationIdsForBatchSend),
              type: isLegacyAdminTab || noteType === 'admin' ? 'application_admin_note' : 'application_customer_note',
              noteTemplateNumber: template_id || undefined,
              contentEncoding: template_id && isMarkdownRendererEnabled || (note === null || note === void 0 ? void 0 : note.content_encoding) === 'markdown' ? 'markdown' : 'html',
              flags: {
                restricted: template.attributes.restricted,
                emailNotification: template.attributes.email_user
              },
              subject: (_note$title = note === null || note === void 0 ? void 0 : note.title) !== null && _note$title !== void 0 ? _note$title : template.attributes.note_title,
              content: (_note$body = note === null || note === void 0 ? void 0 : note.body) !== null && _note$body !== void 0 ? _note$body : template.attributes.content
            }, {
              onSuccess: function onSuccess() {
                var applicationsCount = selectedApplicationIdsForBatchSend.size;
                handleRemoveAllApplicationIds();
                setSendNoteToAllApplications(false);
                setSelectedLegacyApplicationIdsForBatchSend(new Set());
                setSelectedApplicationIdsForBatchSend(new Set());
                toastr.info("Notes will be sent to ".concat(applicationsCount, " applications"));
                closeModalAction();
                setApplicationIsProcessing(false);
              },
              onError: function onError() {
                setApplicationIsProcessing(false);
                toastr.error('Something went wrong while sending the notes');
              }
            });
            return _context2.abrupt("return", true);
          case 4:
            _context2.prev = 4;
            result = null;
            if (!template_id) {
              _context2.next = 12;
              break;
            }
            _context2.next = 9;
            return createBulkNoteTemplateAction(template_id, Array.from(selectedLegacyApplicationIdsForBatchSend), isLegacyAdminTab)["catch"](handleApiErrorResponse);
          case 9:
            result = _context2.sent;
            _context2.next = 15;
            break;
          case 12:
            _context2.next = 14;
            return createBulkNotesAction(note.id, Array.from(selectedLegacyApplicationIdsForBatchSend), isLegacyAdminTab)["catch"](handleApiErrorResponse);
          case 14:
            result = _context2.sent;
          case 15:
            result_data = result ? result.data : null;
            applications_count = result_data && result_data.applications_count ? result_data.applications_count : selectedLegacyApplicationIdsForBatchSend.size;
            handleRemoveAllApplicationIds();
            setSendNoteToAllApplications(false);
            setSelectedLegacyApplicationIdsForBatchSend(new Set());
            setSelectedApplicationIdsForBatchSend(new Set());
            toastr.info("Notes will be sent to ".concat(applications_count, " applications"));
            closeModalAction();
            _context2.next = 28;
            break;
          case 25:
            _context2.prev = 25;
            _context2.t0 = _context2["catch"](4);
            toastr.error('Something went wrong while sending the notes');
          case 28:
            setApplicationIsProcessing(false);
            return _context2.abrupt("return", true);
          case 30:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[4, 25]]);
    }));
  },
  handleCloseModal: function handleCloseModal(_ref8) {
    var closeModalAction = _ref8.closeModalAction,
      handleRemoveAllApplicationIds = _ref8.handleRemoveAllApplicationIds,
      setSendNoteToAllApplications = _ref8.setSendNoteToAllApplications,
      setSelectedLegacyApplicationIdsForBatchSend = _ref8.setSelectedLegacyApplicationIdsForBatchSend,
      setSelectedApplicationIdsForBatchSend = _ref8.setSelectedApplicationIdsForBatchSend;
    return function () {
      handleRemoveAllApplicationIds();
      setSendNoteToAllApplications(false);
      setSelectedLegacyApplicationIdsForBatchSend(new Set());
      setSelectedApplicationIdsForBatchSend(new Set());
      closeModalAction();
    };
  },
  onToggleSendNoteToAllApplications: function onToggleSendNoteToAllApplications(_ref9) {
    var sendNoteToAllApplications = _ref9.sendNoteToAllApplications,
      setSendNoteToAllApplications = _ref9.setSendNoteToAllApplications,
      setSelectedLegacyApplicationIdsForBatchSend = _ref9.setSelectedLegacyApplicationIdsForBatchSend,
      setSelectedApplicationIdsForBatchSend = _ref9.setSelectedApplicationIdsForBatchSend,
      legacyApplicationIds = _ref9.application_ids,
      applicationsMap = _ref9.applications_map;
    return function () {
      var newToggleState = !sendNoteToAllApplications;
      setSelectedLegacyApplicationIdsForBatchSend(new Set(newToggleState ? legacyApplicationIds : []));
      var applicationIds = legacyApplicationIds.map(function (legacyApplicationId) {
        var _applicationsMap$lega;
        return (_applicationsMap$lega = applicationsMap[legacyApplicationId]) === null || _applicationsMap$lega === void 0 ? void 0 : _applicationsMap$lega.new_id;
      }).filter(Boolean);
      setSelectedApplicationIdsForBatchSend(new Set(newToggleState ? applicationIds : []));
      setSendNoteToAllApplications(newToggleState);
    };
  },
  onToggleSendNoteToApplication: function onToggleSendNoteToApplication(_ref10) {
    var selectedLegacyApplicationIdsForBatchSend = _ref10.selectedLegacyApplicationIdsForBatchSend,
      setSelectedLegacyApplicationIdsForBatchSend = _ref10.setSelectedLegacyApplicationIdsForBatchSend,
      selectedApplicationIdsForBatchSend = _ref10.selectedApplicationIdsForBatchSend,
      setSelectedApplicationIdsForBatchSend = _ref10.setSelectedApplicationIdsForBatchSend,
      setSendNoteToAllApplications = _ref10.setSendNoteToAllApplications,
      application_ids = _ref10.application_ids,
      applicationsMap = _ref10.applications_map;
    return function (event) {
      var legacyApplicationId = parseInt(event.target.name);
      if (selectedLegacyApplicationIdsForBatchSend.has(legacyApplicationId)) {
        selectedLegacyApplicationIdsForBatchSend["delete"](legacyApplicationId);
      } else {
        selectedLegacyApplicationIdsForBatchSend.add(legacyApplicationId);
      }
      setSelectedLegacyApplicationIdsForBatchSend(new Set(selectedLegacyApplicationIdsForBatchSend));
      setSendNoteToAllApplications(selectedLegacyApplicationIdsForBatchSend.size == application_ids.length);
      var applicationId = applicationsMap[legacyApplicationId].new_id;
      if (selectedApplicationIdsForBatchSend.has(applicationId)) {
        selectedApplicationIdsForBatchSend["delete"](applicationId);
      } else {
        selectedApplicationIdsForBatchSend.add(applicationId);
      }
      setSelectedApplicationIdsForBatchSend(new Set(selectedApplicationIdsForBatchSend));
    };
  },
  downloadCsvHandler: function downloadCsvHandler(_ref11) {
    var downloadCsv = _ref11.downloadCsv,
      setDownloadCsv = _ref11.setDownloadCsv;
    return function (event) {
      event.stopPropagation();
      setDownloadCsv(!downloadCsv);
    };
  }
}), withProps(function (_ref12) {
  var template_id = _ref12.template_id,
    template = _ref12.template,
    note = _ref12.note,
    isMarkdownRendererEnabled = _ref12.isMarkdownRendererEnabled;
  var content = {};
  try {
    if (template_id) {
      content.type = 'template';
      content.sendingToRp = template.attributes.email_user;
      content.visibility = template.attributes.visibility;
      content.body = {
        text: isMarkdownRendererEnabled ? template.attributes.content : template.attributes.text,
        templateTitle: template.attributes.title,
        title: template.attributes.note_title
      };
    } else if (note) {
      content.type = 'note';
      content.body = {
        text: note.body,
        title: note.title,
        contentEncoding: note.content_encoding
      };
      content.sendingToRp = note.email_user;
      content.visibility = note.visibility;
    }
  } catch (e) {
    console.error(e);
  }
  return {
    content: content
  };
}), withPropsOnChange(['application_ids', 'current_application_id', 'current_application', 'applications_map', 'selectedLegacyApplicationIdsForBatchSend'], function (_ref13) {
  var application_ids = _ref13.application_ids,
    applications_map = _ref13.applications_map,
    current_application_id = _ref13.current_application_id,
    current_application = _ref13.current_application,
    selectedLegacyApplicationIdsForBatchSend = _ref13.selectedLegacyApplicationIdsForBatchSend;
  var applications = [];
  application_ids.forEach(function (application_id) {
    var app = application_id == current_application_id ? current_application : applications_map[application_id];
    var mostRecentAuthorType = applications_map[application_id] && applications_map[application_id].most_recent_note_author_type;
    if (app && app.student && app.program && (app.program.school || app.school)) {
      var statuses = app.status && Object.entries(app.status).filter(function (ele) {
        return ele[1] === true;
      }).map(function (ele) {
        return ele[0];
      }) || [];
      if (!statuses.length) {
        if (app.paid) statuses.push('processing');else if (app.payment_verification_pending) statuses.push('verification_pending');else statuses.push('payment_pending');
      }
      applications.push({
        id: app.id,
        student: [app.student && app.student.first_name || app.student && app.student.personal_information && app.student.personal_information.first_name, app.student && app.student.middle_name || app.student && app.student.personal_information && app.student.personal_information.middle_name, app.student && app.student.last_name || app.student && app.student.personal_information && app.student.personal_information.last_name].filter(function (e) {
          return !!e;
        }).join(' '),
        school: app.program.school && app.program.school.name || app.school.name,
        program: app.program.name,
        status: statuses.join(' '),
        postedBy: mostRecentAuthorType,
        createdAt: moment(app.created_at).format('lll'),
        sentStatus: selectedLegacyApplicationIdsForBatchSend && selectedLegacyApplicationIdsForBatchSend.has(app.id) ? 'sent' : 'skipped'
      });
    }
  });
  return {
    dataForCSV: applications
  };
}));
export default enhancer;